import React from "react";
import PropTypes from "prop-types";

// Pulsing placeholder rows for a table mid-load. Renders `rows` <tr>s of
// `cols` pulsing bars, meant to be dropped inside a <tbody> in place of
// real rows — it has no knowledge of what the real columns represent.
//
// The <tr>/<td> classes are deliberately the SAME strings DataTable gives a real
// row and cell (`border-t border-gray-100 h-14` / `pl-3 py-4`). They used to differ
// (`px-4 py-3`, a bottom border), which made the table visibly jump the instant data
// landed. Any change to DataTable's row or cell padding must be mirrored here.
function TableSkeleton({ rows, cols }) {
    return (
        <>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={rowIndex} className="border-t border-gray-100 h-14">
                    {Array.from({ length: cols }).map((_, colIndex) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <td key={colIndex} className="pl-3 py-4">
                            <div
                                className="h-3 animate-pulse rounded bg-gray-200"
                                style={{ width: colIndex === 0 ? "40%" : "75%" }}
                            />
                        </td>
                    ))}
                </tr>
            ))}
        </>
    );
}

TableSkeleton.propTypes = {
    rows: PropTypes.number,
    cols: PropTypes.number,
};

TableSkeleton.defaultProps = {
    rows: 5,
    cols: 4,
};

export default TableSkeleton;
